import { Search } from "./../pages/components/Search"
import { TopRightDropdown } from "./TopRightDropdown"
import { HamburgerMenu } from "./../layout/images/GeneralIcons"
import { Link } from "react-router-dom"
import { BrandLogo } from "./components/BrandLogo"

export const TopMenu = ({username, credits, subscriptionPackage, onMenuToggle}) => {
    const handleMenuToggle = () => {
        onMenuToggle()
    }

    return (  
        <>
            <header className="sticky top-0 z-20 flex h-[72px] w-full items-center border-b border-slate-200 bg-white/95 px-4 shadow-sm backdrop-blur sm:px-6 lg:px-8">
                <div className="flex w-full items-center justify-between gap-4">
                    <div className="flex min-w-0 flex-1 items-center gap-5">
                        <BrandLogo/>
                        <div className="hidden min-w-0 flex-1 md:block">
                            <Search/>
                        </div>
                    </div>
                    <div className="flex shrink-0 items-center gap-3">
                        <TopRightDropdown username={username}/>
                        <button 
                            className="flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-600 shadow-sm lg:hidden"
                            onClick={() => handleMenuToggle()}
                            aria-label="Open navigation"
                            type="button"
                        >
                            <HamburgerMenu/>
                        </button>
                    </div>
                </div>
            </header>
            {subscriptionPackage === 'full' ||
            <div className="border-b border-emerald-200 bg-emerald-50 px-4 py-2 text-center text-sm font-medium text-emerald-800">
                You have {credits} searches left in your free plan. To unlock more searches, <Link to="/my/subscription" className="underline decoration-emerald-500 underline-offset-2">upgrade your plan</Link>.
            </div>
            }
        </>
    )
}
